/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * 2020-03-09 董浩
 * 排序
 * dataList: 待排序的集合
 * key: 排序字段
 * orderType: 排序类型，asc:升序(默认)；desc: 降序
 * @return 排序后的集合
 * */
export function getOrderByList(dataList, key, orderType) {
  return dataList.sort((a, b) => {
    var x = a[key]
    var y = b[key]

    if (orderType === 'desc') {
      return ((x > y) ? -1 : ((x < y) ? 1 : 0))
    } else {
      return ((x < y) ? -1 : ((x > y) ? 1 : 0))
    }
  })
}

/**
 * 2020-03-23 董浩
 * 检核空对象
 * */
export function isStringBlank(str) {
	return (str === null || str === undefined || str === 'null' || str === 'undefined' || str === '');
}

export function formatNum(number, decimals, decPoint, thousandsSep, roundtag) {
	decimals = decimals || decimals === 0 ? decimals : 2;
	decPoint = decPoint ? decPoint : '.';
	thousandsSep = thousandsSep ? thousandsSep : ',';

	number = (number + '').replace(/[^0-9+-Ee.]/g, '');
	roundtag = roundtag || 'ceil'; // "ceil","floor","round"
	var n = !isFinite(+number) ? 0 : +number;
	var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
	var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
	var s = '';
	var toFixedFix = function(n, prec) {
		var k = Math.pow(10, prec);
		return '' + parseFloat(Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)) / k;
	};
	s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
	var re = /(-?\d+)(\d{3})/;
	while (re.test(s[0])) {
		s[0] = s[0].replace(re, '$1' + sep + '$2');
	}
	if ((s[1] || '').length < prec) {
		s[1] = s[1] || '';
		s[1] += new Array(prec - s[1].length + 1).join('0');
	}
	return s.join(dec);
}